module.exports = __webpack_public_path__ + "media/images/weather/21_day-7088b66efe5d94a793eaf73d720cd9ab.png";